import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div<{ rowRecord: any }>`
  overflow: auto;
  ${theme.hideScrollbar};
  background: ${theme.colors.white};
  .ant-pagination-options:not(:disabled) {
    .ant-select-selector {
      border: 1px solid #8e8c8c;
    }
    .anticon {
      svg {
        color: rgb(38, 38, 38);
      }
    }
  }

  .ant-pagination-item-link:not(:disabled) {
    border-color: #8e8c8c;
    .anticon {
      svg {
        color: rgb(38, 38, 38);
      }
    }
  }

  .ant-pagination-item-active,
  .ant-pagination-item-active a {
    background: ${theme.colors.primary};
    color: ${theme.colors.custom.darkblue3};
    font-size: 16px;
    font-weight: 700;
    border-radius: 4px;
  }

  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    background: ${theme.colors.white};
    font-family: "Orkney Bold";

    & > .ant-table-filter-column > .ant-table-column-title {
      font-family: "Orkney Bold";
    }

    &::before {
      opacity: 0;
    }

    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 14.4px;
      font-weight: 700;
      line-height: 18px;
      padding: 8px;
    }
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #d6cdcd;
  }

  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media ${theme.breakpoints.mobileAndTablet} {
      padding: 10px;
      font-size: 12.6px;
      line-height: 16px;
      font-weight: 400;
    }
  }
  .ant-table-tbody > tr:hover > td,
  .ant-table tfoot > tr:hover,
  .ant-table tfoot > tr:hover {
    ${(props) => props.rowRecord && "cursor: pointer;"}
  }

  /* .ant-table-content: {
    border-radius: 40px;
  } */

  .ant-table-filter-trigger {
    margin-top: -7px;
    margin-left: 8px;
    font-size: 15px;
  }

  .ant-table-filter-trigger.active {
    color: ${theme.colors.secondary};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    display: none;
  }

  .ant-table-filter-column {
    display: flex;
    position: absolute;
    top: 15px;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid ${theme.colors.grey};
  }

  /* safari fix */
  .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 45px 0;
    background: ${theme.colors.custom.background};

    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border: 2px solid ${theme.colors.custom.darkblue3};
      border-radius: 4px;
    }

    .ant-pagination-disabled .ant-pagination-item-link {
      border: 2px solid ${theme.colors.grey};
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 45px 0;
    background: ${theme.colors.custom.background};

    .ant-pagination-item:not(.ant-pagination-item-active),
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link,
    .ant-select:not(.ant-select-customize-input) .ant-select-selector,
    .ant-pagination-disabled .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link,
    .ant-pagination-disabled:focus-visible .ant-pagination-item-link {
      border: 2px solid ${theme.colors.custom.darkblue3};
      border-radius: 4px;
    }

    .ant-pagination-disabled .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link,
    .ant-pagination-disabled:focus-visible .ant-pagination-item-link {
      border: 2px solid ${theme.colors.grey};
    }
    .ant-pagination-item-link {
      .ant-pagination-disabled {
        border: 2px solid #273049;
      }

      .anticon-right,
      .anticon-left {
        vertical-align: 0;
      }
    }

    .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
    .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
      font-size: 16px;
      font-weight: 700;
    }
  }
`;
